// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Fix: Re-initialize mobile menu on Turbo navigation
function initializeMobileMenu() {
  // Wait for jQuery and menu functions to be available
  if (typeof jQuery === 'undefined' || typeof jQuery.fn.mfnMenu === 'undefined') {
    // jQuery not loaded yet, wait a bit and try again
    setTimeout(initializeMobileMenu, 50);
    return;
  }

  const $ = jQuery;
  const mobile_init_W = 768;
  const windowWidth = $(window).width();

  // Handle menu placement based on screen size
  if ($('body').hasClass('mobile-side-slide')) {
    const slide = $('#Side_slide');
    const menuWrapper = $('#Side_slide .menu_wrapper');
    const topBarMenuWrapper = $('#Top_bar .menu_wrapper');

    if (windowWidth < 1240) {
      // MOBILE/TABLET: Move menu into side slide
      if (menuWrapper.find('nav#menu').length === 0 && $('nav#menu').length > 0) {
        menuWrapper.empty();
        $('nav#menu').detach().appendTo(menuWrapper);
        slide.addClass('enabled');
      }
    } else {
      // DESKTOP: Move menu back to top bar if it's in the sidebar
      if (menuWrapper.find('nav#menu').length > 0 && topBarMenuWrapper.length > 0) {
        $('nav#menu').detach().prependTo(topBarMenuWrapper);
        slide.removeClass('enabled');
      }
    }

    // Re-attach responsive menu toggle handler for side slide
    $('.responsive-menu-toggle').off('click').on('click', function(e) {
      e.preventDefault();

      const pos = slide.hasClass('left') ? 'left' : 'right';
      const overlay = $('#body_overlay');

      // Show slide menu
      if (pos === 'left') {
        slide.animate({ 'left': 0 }, 300);
        $('body').animate({ 'right': -125 }, 300);
      } else {
        slide.animate({ 'right': 0 }, 300);
        $('body').animate({ 'left': -125 }, 300);
      }

      overlay.fadeIn(300);
    });

    // Handle overlay click to close
    $('#body_overlay').off('click').on('click', function() {
      const pos = slide.hasClass('left') ? 'left' : 'right';

      if (pos === 'left') {
        slide.animate({ 'left': -250 }, 300);
        $('body').animate({ 'right': 0 }, 300);
      } else {
        slide.animate({ 'right': -250 }, 300);
        $('body').animate({ 'left': 0 }, 300);
      }

      $('#body_overlay').fadeOut(300);
    });

    // Handle close button
    $('#Side_slide .close').off('click').on('click', function(e) {
      e.preventDefault();
      const pos = slide.hasClass('left') ? 'left' : 'right';

      if (pos === 'left') {
        slide.animate({ 'left': -250 }, 300);
        $('body').animate({ 'right': 0 }, 300);
      } else {
        slide.animate({ 'right': -250 }, 300);
        $('body').animate({ 'left': 0 }, 300);
      }

      $('#body_overlay').fadeOut(300);
    });
  }

  // Re-initialize main menu with mfnMenu plugin
  let mm_mobile_init_W = mobile_init_W;

  if ($('body').hasClass('header-simple') || $('#Header_creative.dropdown').length) {
    mm_mobile_init_W = 9999;
  }

  // Clear any existing menu initialization
  $('#menu > ul.menu').off('.mfnMenu');

  // Re-initialize mfnMenu
  if ($('#menu > ul.menu').length) {
    $('#menu > ul.menu').mfnMenu({
      addLast: true,
      arrows: true,
      mobileInit: mm_mobile_init_W,
    });
  }

  if ($('#secondary-menu > ul.secondary-menu').length) {
    $('#secondary-menu > ul.secondary-menu').mfnMenu({
      mobileInit: mm_mobile_init_W,
    });
  }
}

// Run on both initial load and Turbo navigation
document.addEventListener('turbo:load', initializeMobileMenu);
document.addEventListener('DOMContentLoaded', initializeMobileMenu);
